import React from "react";
import DashboardLayout from '../DashboardLayout';
import LocationsContent from "../../../../components/LocationsContent";
import EnquiriesContent from "../../../../components/EnquiriesContent";
import { Col, Row } from 'react-bootstrap';
function Locations({ user }) {
  return (
    <DashboardLayout user={user}>
      <Row>
        <Col lg={6}>
          <LocationsContent/>
        </Col>
        <Col lg={6}>
          <EnquiriesContent />
        </Col>
      </Row>
    </DashboardLayout>
  );
}

export default Locations;
